import { Theme, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FormHeader } from '../FormHeader';
import { BackButton } from 'components';
import { OrganizationPanel } from './components';

import styles from './YourOrganization.module.scss';

type OrganizationProps = {
  onBackToSettingsClick(): void;
};

export function YourOrganizationSettings({ onBackToSettingsClick }: OrganizationProps) {
  const { t } = useTranslation('settings');
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <>
      {isMobile && <BackButton text={t('yourOrganizationSettings.backToSettings')} onClick={onBackToSettingsClick} />}
      <div className={styles.container}>
        <FormHeader items={[{ text: t('yourOrganizationSettings.organizationDetailsUpper'), isSelected: true }]} />
        <div className={styles.main}>
          <OrganizationPanel />
        </div>
      </div>
    </>
  );
}
